import { type State } from './state.js';

// This is being disabled because the exhaustive check rule renders this check unnecessary
// If this rule is not disabled, the last return statement will be 'unreachable code'
// eslint-disable-next-line consistent-return
export const handleGoBack = (state: State): State => {
  switch (state.view) {
    case null:

    case 'VIEW_Crypto_Disclaimer':

    case 'VIEW_Crypto_Education':
    case 'VIEW_Payoneer_Return':
    case 'VIEW_Payout_Setup_Successful':
    case 'VIEW_Paypal_Return':
    case 'VIEW_Persona_Failure':
    case 'VIEW_Stripe_Return': {
      return state;
    }

    case 'VIEW_Airwallex_Beneficiary_Form':
    case 'VIEW_Bank_Account_Form':

    case 'VIEW_Crypto_Form':
    case 'VIEW_Debit_Card_Form':

    case 'VIEW_Paypal_Connect_Form':
    case 'VIEW_Stripe_More_Information': {
      return {
        ...state,
        view: 'VIEW_Select_Payout_Method',
      };
    }

    case 'VIEW_Country_Not_Supported':
    case 'VIEW_Sanctioned_Country': {
      return {
        ...state,
        view: 'VIEW_Select_Country',
      };
    }

    case 'VIEW_Persona':
    case 'VIEW_Persona_Update_Location': {
      return {
        ...state,
        view: 'VIEW_Persona_Note',
      };
    }

    case 'VIEW_Persona_Note':
    case 'VIEW_Stripe_Note': {
      return {
        ...state,
        view: 'VIEW_Select_Payout_Method',
      };
    }

    case 'VIEW_Select_Country': {
      return {
        ...state,
        view: null,
      };
    }

    case 'VIEW_Select_Payout_Method': {
      if (state.canEditCountry) {
        return {
          ...state,
          view: 'VIEW_Select_Country',
        };
      }

      return {
        ...state,
        view: null,
      };
    }
  }
};
